

export function getAddonValue(
addonConstant, value, fallback)
{
  if (!Array.isArray(addonConstant) || addonConstant.length === 0) {
    return fallback;
  }

  if (typeof addonConstant[0].value === 'boolean') {
    return addonConstant.find((constant) => constant.value);
  }

  const addonValue = addonConstant.find((constant) => constant.value === value);

  return addonValue || fallback;
}

export function getAddonLabel(
addonConstant,
addonObject,
fallback)
{
  if (!addonObject) {return { label: fallback };}

  const { value, status, rejectionReason } = addonObject;
  const formattedAddonValue = getAddonValue(addonConstant, value, fallback);

  return {
    ...formattedAddonValue,
    status,
    rejectionReason
  };
}

export function getFormattedAddon({
  ADDITIONAL_OUTPUT,
  CHROMA_KEY,
  DURATIONS,
  RUSH_EDIT,
  VOICE_OVER_ARTIST






}) {
  return function formattedAddon(addonType, addons, fallback) {
    if (addonType === 'BURN_IN_CAPTIONS' ||
    addonType === 'SRT_CAPTIONS' ||
    addonType === 'SUPERSIZE_MY_EDIT') {return fallback;}

    const addon = addons[addonType];

    if (!addon) {return fallback;}

    if (addonType === 'ADDITIONAL_OUTPUT') {return getAddonLabel(ADDITIONAL_OUTPUT, addon, fallback);}
    if (addonType === 'CHROMA_KEY') {return getAddonLabel(CHROMA_KEY, addon, fallback);}
    if (addonType === 'DURATION') {return getAddonLabel(DURATIONS, addon, fallback);}
    if (addonType === 'RUSH_EDIT') {return getAddonLabel(RUSH_EDIT, addon, fallback);}
    if (addonType === 'VOICE_OVER_ARTIST' || addonType === 'VOICE_OVER_ARTISTS') {return getAddonLabel(VOICE_OVER_ARTIST, addon, fallback);}

    return fallback;
  };
}